export const APIErrorCodes: Record<number, string> = {
  [-1]: 'InternalSystemError',
  2: 'AccessKeyError',
  3: 'AuthenticationFailedError',
  4: 'InputError',
  5: 'AuthenticationError',
  6: 'DuplicateUsernameError',
  9: 'RateLimitError',
  16: 'DoesNotExistError',
  17: 'NotAllowedError',
  18: 'EventNotSupportedError',
  19: 'ChannelFeatureNotSupportedError',
  20: 'MessageTooLongError',
  21: 'MultipleNestingLevelError',
  22: 'PayloadTooBigError',
  23: 'RequestTimeoutError',
  24: 'MaxHeaderSizeExceededError',
  40: 'AuthErrorTokenExpired',
  41: 'AuthErrorTokenNotValidYet',
  42: 'AuthErrorTokenUsedBeforeIssuedAt',
  43: 'AuthErrorTokenSignatureInvalid',
  44: 'CustomCommandEndpointMissingError',
  45: 'CustomCommandEndpointCallError',
  46: 'ConnectionIDNotFoundError',
  60: 'CoolDownError',
  69: 'ErrWrongRegion',
  70: 'ErrQueryChannelPermissions',
  71: 'ErrTooManyConnections',
  73: 'MessageModerationFailedError',
  99: 'AppSuspendedError',
};
